import React from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';

import ListView from './ListView/ListView';
import GridView from './GridView/GridView';
import { useEffect } from 'react';

import PreviewModal from './Modals/PreviewModal/PreviewModal';
import AddTagModal from './Modals/AddTagModal';
import ShareModal from './Modals/ShareModal';
import RenameModal from './Modals/RenameModal';
import MoveItemModal from './Modals/MoveItemModal';
import DeleteConfirmationModal from './Modals/DeleteConfirmationModal';
import BulkDeleteConfirmationModal from './Modals/BulkDeleteConfirmationModal';
import BulkMoveItemModal from './Modals/BulkMoveItemModal';

import FileUploadModal from './Modals/File Upload/FileUploadModal';
import FileVersionsModal from './Modals/FileVersionsModal/FileVersionsModal';
import CreateFolderModal from './Modals/CreateFolderModal';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import CreateDocumentModal from './Modals/CreateDocumentModal';
import SignatureModal from './Modals/SignatureModal/SignatureModal';
import SignatureStatusModal from './Modals/SignatureModal/signatureStatus';
import FileSummarizeModal from './Modals/SummarizeModal';
import DiscrepancyModal from './Modals/DiscrepancyModal/DiscrepancyModal';
import CreateCourtEventModal from './Modals/CourtNotice/CreateCourtEventModal';
import SendFaxModal from './Modals/sendFaxModal/sendFax';
import { useLocation } from 'react-router-dom';

function FileManagerView() {
  const {
    currentView,
    fileManagerFilters,
    getFiles,
    breadCrumbs,
    setBreadCrumbs,
    filterBreadCrumbs,
    modals,
    onFilterChange,
    pageLimit,
    isGlobalFileManager,
    caseDetails,
    isClientFileManager,
    query,
    selectedPreviewItem,
    setSelectedPreviewItem,
    setPreviewList,
    files,
    setFileManagerFilters,
  } = useFileManagerContext();

  const {
    showPreview,
    showShareFileModal,
    showAddTag,
    showRenameModal,
    moveItemModal,
    showDeleteModal,
    showBulkDeleteModal,
    showBulkMoveModal,
    showFileUploadModal,
    showUploadedVersionsModal,
    showCreateFolderModal,
    showCreateDocumentModal,
    showSignatureModal,
    showEsignStatusModal,
    showSummarizeModal,
    showDiscrepancyModal,
    showCreateEventModal,
    showSendFaxModal,
    setShowPreview,
  } = modals;

  const location = useLocation();

  useEffect(() => {
    const getFiledata = () => {
      const queryParams = new URLSearchParams(location.search);
      const fileId = queryParams.get('file_id');

      if (fileId && selectedPreviewItem?.object_id !== fileId) {
        const selectedFile = files.find((item) => item.entry_type === 'file' && item?.object_id === fileId);
        if (selectedFile) {
          setShowPreview(true);
          setPreviewList(files);
          setSelectedPreviewItem(selectedFile);
        }
      }
    };

    if (location.search && files?.length > 0) {
      getFiledata();
    }
    if (location.search === '') {
      setShowPreview(false);
      setSelectedPreviewItem();
    }
  }, [location.search, files, selectedPreviewItem]);

  const home = {
    icon: 'pi pi-home',
    command: (e) => {
      let data = {
        target: {
          name: 'selectedFolder',
        },
        value: '',
        // Reset shared_folder to false when going to Home for proper client view
        shared_folder: false,
        // Clear folder_shared and shared_contact_list when going home
        folder_shared: null,
        shared_contact_list: null,
      };
      onFilterChange(data, clearBreadcrumbs);
    },
  };

  function clearBreadcrumbs() {
    setBreadCrumbs([]);
  }

  return (
    <>
      {/* Hide breadcrumb completely for global file manager */}
      {/* {!isGlobalFileManager && ( */}
      <BreadCrumb
        model={breadCrumbs?.map((item) => {
          item.command = (e) => {
            let obj = {
              case_id: isGlobalFileManager || isClientFileManager ? fileManagerFilters.case?.id || '' : caseDetails?.case_id,
              selectedFolder: e.item.value,
              selectedType: fileManagerFilters.fileType,
              tag: fileManagerFilters.tag,
              query: query,
              folder_id: e.item.value,
              // Use the correct filter field based on file manager type
              is_read: isGlobalFileManager ? fileManagerFilters?.is_read : fileManagerFilters?.fileStatus,
              // Preserve shared_folder flag for breadcrumb navigation
              ...(fileManagerFilters?.shared_folder && { shared_folder: fileManagerFilters.shared_folder }),
            };
            getFiles(obj, currentView, pageLimit);
            setFileManagerFilters((preVal) => ({
              ...preVal,
              folder_id: e.item.value,
              selectedFolder: e.item.value,
              // Clear folder_shared and shared_contact_list during breadcrumb navigation
              folder_shared: undefined,
              shared_contact_list: undefined,
            }));
            filterBreadCrumbs(e.item.value);
          };
          return item;
        })}
        home={home}
      />
      {/* )} */}

      <div className={`rounded casefile-wrap ${currentView === 'list' ? 'datatable-responsive' : ''}`}>
        {currentView === 'list' ? <ListView /> : <GridView />}
      </div>
      {showPreview && <PreviewModal />}
      {showAddTag && <AddTagModal />}
      {showShareFileModal && <ShareModal />}
      {showRenameModal && <RenameModal />}
      {moveItemModal && <MoveItemModal />}
      {showDeleteModal && <DeleteConfirmationModal />}
      {showBulkDeleteModal && <BulkDeleteConfirmationModal />}
      {showBulkMoveModal && <BulkMoveItemModal />}

      {showFileUploadModal && <FileUploadModal />}
      {showUploadedVersionsModal && <FileVersionsModal />}
      {showCreateFolderModal && <CreateFolderModal />}
      {showCreateDocumentModal && <CreateDocumentModal />}
      {showDiscrepancyModal && <DiscrepancyModal />}
      {showSignatureModal && <SignatureModal />}
      {showEsignStatusModal && <SignatureStatusModal />}
      {showSummarizeModal && <FileSummarizeModal />}
      {showCreateEventModal && <CreateCourtEventModal />}
      {showSendFaxModal && <SendFaxModal />}
    </>
  );
}

export default FileManagerView;
